import { Client, Message, User } from '@twilio/conversations';
import { UserInfo } from 'src/app/interfaces';
import { TWILIO_AUTO_CONVERSATION_TITLE, TwilioMessageAttributes } from '../services/twilio/twilio.interfaces';
import { ConversationsAdapter } from './conversations.adapter';

export function twilioMessageAttributes(message: Message): TwilioMessageAttributes {
  return message.attributes as unknown as TwilioMessageAttributes;
}

export function findMessageBySid(messages: Message[], messageSid: string): Message | null {
  const message: Message | undefined = messages ? messages.find((m: Message) => m.sid === messageSid) : undefined;
  return message ? message : null;
}

export function findMessageIndexBySid(messages: Message[], sid: string): number {
  return messages ? messages.findIndex((m: Message) => m.sid === sid) : -1;
}

export function createTwilioConversationTitle(title: string, userName: string): string {
  return title
    .split("'")[1]
    .split(', ')
    .filter((name: string) => name !== userName)
    .sort((name1: string, name2: string) => name1.localeCompare(name2))
    .join(', ');
}

export function computeConversationEffectiveTitle(
  customTitle: string | null,
  users: UserInfo[],
  currentUserId: string,
): string {
  if (customTitle && customTitle !== TWILIO_AUTO_CONVERSATION_TITLE) {
    return customTitle;
  }
  return users
    .filter((user: UserInfo) => user.userId !== currentUserId)
    .map((channelUser: UserInfo) => channelUser.userName)
    .sort((name1: string, name2: string) => name1.localeCompare(name2))
    .join(', ');
}

export async function getTwilioMessageAuthorUser(
  twilioClient: Client,
  message: Message,
  currentChannelUsers: UserInfo[],
  userBlockedbyCurrentUser: string[],
): Promise<UserInfo> {
  const authorInfoBetweenParticipants: UserInfo | undefined = currentChannelUsers.find(
    (u: UserInfo) => u.userId === message.author,
  );
  if (authorInfoBetweenParticipants) {
    return authorInfoBetweenParticipants;
  } else {
    const user: User = await twilioClient.getUser(message.author);
    return ConversationsAdapter.adaptTwilioUserToUserInfo(user, userBlockedbyCurrentUser);
  }
}
